import React from 'react'
import { alpha } from '@mui/material/styles'
import { Box, Button } from '@mui/material'
import PropTypes from 'prop-types'
import LanguageIcon from '@mui/icons-material/Language'
import ExtensionIcon from '@mui/icons-material/Extension'
import AndroidIcon from '@mui/icons-material/Android'
import { Preview } from './common/style'
import Teaser from './common/Teaser'
import Screenshots from './common/Screenshots'
import Summary from './common/Summary'
import Contribution from './common/Contribution'
import { ProjectDialogContent } from '.'

export default function ProjectCatty({ color, screenshots, summary, contribution }) {

  return (
    <ProjectDialogContent>
      <Preview alt='growup' src='/static/works/catty.png' />
      <Box
        sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center', mb: 10 }}
      >
        <Button
          size='large'
          variant='contained'
          startIcon={<LanguageIcon />}
          disabled
          sx={{ '&.Mui-disabled': { color, backgroundColor: alpha(color, 0.12), border: `1px solid ${alpha(color, 0.25)}` }, textTransform: 'none' }}
        >
          {'Web (currently unavailable)'}
        </Button>
        <Button
          size='large'
          variant='contained'
          startIcon={<ExtensionIcon />}
          disabled
          sx={{ '&.Mui-disabled': { color, backgroundColor: alpha(color, 0.12), border: `1px solid ${alpha(color, 0.25)}` }, textTransform: 'none' }}
        >
          {'Extension (currently unavailable)'}
        </Button>
        <Button
          size='large'
          variant='contained'
          startIcon={<AndroidIcon />}
          disabled
          sx={{ '&.Mui-disabled': { color, backgroundColor: alpha(color, 0.12), border: `1px solid ${alpha(color, 0.25)}` }, textTransform: 'none' }}
        >
          {'Android (currently unavailable)'}
        </Button>
      </Box>
      <Summary color={color} summary={summary} />
      <Contribution color={color} contribution={contribution} />
      <Teaser color={color} videoId='n-lB4uCQyGQ' />
      <Screenshots color={color} screenshots={screenshots} alt='catty' />
    </ProjectDialogContent>
  )
}

Teaser.propTypes = {
  color: PropTypes.string,
}

ProjectCatty.propTypes = {
  color: PropTypes.string,
  screenshots: PropTypes.array,
  summary: PropTypes.object,
  contribution: PropTypes.array
}
